/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function getOrderHeaderDetailsActionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getOrderHeaderDetailsActionInput(
    dealerCode: string,
    pageNumber: number,
    pageSize: number,
    orderNumber: string,
    orderDatefrom: string,
    orderDateTo: string,
    dealerPONO: string,
    orderStatus: string,
    projectName: string,
    actualMinOrderAmount: string,
    actualMaxOrderAmount: string
): IDataServiceRequest {
    const query = getOrderHeaderDetailsActionQuery();
    return query.createDataServiceRequestForOperation(
        'GetOrderHeaderDetailsAction',
        true,
        DataServiceEntities.ApiResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponse' },
        {
            dealerCode: dealerCode,
            pageNumber: pageNumber,
            pageSize: pageSize,
            orderNumber: orderNumber,
            orderDatefrom: orderDatefrom,
            orderDateTo: orderDateTo,
            dealerPONO: dealerPONO,
            orderStatus: orderStatus,
            projectName: projectName,
            actualMinOrderAmount: actualMinOrderAmount,
            actualMaxOrderAmount: actualMaxOrderAmount
        }
    );
}

export function getOrderHeaderDetailsActionAsync(
    context: IContext,
    dealerCode: string,
    pageNumber: number,
    pageSize: number,
    orderNumber: string,
    orderDatefrom: string,
    orderDateTo: string,
    dealerPONO: string,
    orderStatus: string,
    projectName: string,
    actualMinOrderAmount: string,
    actualMaxOrderAmount: string
): AsyncResult<DataServiceEntities.IApiResponse> {
    const request = getOrderHeaderDetailsActionInput(
        dealerCode,
        pageNumber,
        pageSize,
        orderNumber,
        orderDatefrom,
        orderDateTo,
        dealerPONO,
        orderStatus,
        projectName,
        actualMinOrderAmount,
        actualMaxOrderAmount
    );
    return callActionOrExecute<DataServiceEntities.IApiResponse>(request, context.callerContext);
}

function getOrderLinesDetailsActionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getOrderLinesDetailsActionInput(
    dealerCode: string,
    pageNumber: number,
    pageSize: number,
    orderNumber: string
): IDataServiceRequest {
    const query = getOrderLinesDetailsActionQuery();
    return query.createDataServiceRequestForOperation(
        'GetOrderLinesDetailsAction',
        true,
        DataServiceEntities.ApiResponseForSalesLinesExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseForSalesLines' },
        {
            dealerCode: dealerCode,
            pageNumber: pageNumber,
            pageSize: pageSize,
            orderNumber: orderNumber
        }
    );
}

export function getOrderLinesDetailsActionAsync(
    context: IContext,
    dealerCode: string,
    pageNumber: number,
    pageSize: number,
    orderNumber: string
): AsyncResult<DataServiceEntities.IApiResponseForSalesLines> {
    const request = getOrderLinesDetailsActionInput(dealerCode, pageNumber, pageSize, orderNumber);
    return callActionOrExecute<DataServiceEntities.IApiResponseForSalesLines>(request, context.callerContext);
}

function getPaymentDetailsActionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getPaymentDetailsActionInput(
    dealerCode: string,
    pageNumber: number,
    pageSize: number,
    invoiceNumber: string,
    invoiceAmount: string
): IDataServiceRequest {
    const query = getPaymentDetailsActionQuery();
    return query.createDataServiceRequestForOperation(
        'GetPaymentDetailsAction',
        true,
        DataServiceEntities.ApiResponseForPaymentExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseForPayment' },
        {
            dealerCode: dealerCode,
            pageNumber: pageNumber,
            pageSize: pageSize,
            invoiceNumber: invoiceNumber,
            invoiceAmount: invoiceAmount
        }
    );
}

export function getPaymentDetailsActionAsync(
    context: IContext,
    dealerCode: string,
    pageNumber: number,
    pageSize: number,
    invoiceNumber: string,
    invoiceAmount: string
): AsyncResult<DataServiceEntities.IApiResponseForPayment> {
    const request = getPaymentDetailsActionInput(dealerCode, pageNumber, pageSize, invoiceNumber, invoiceAmount);
    return callActionOrExecute<DataServiceEntities.IApiResponseForPayment>(request, context.callerContext);
}

function getShipmentDetailsActionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getShipmentDetailsActionInput(
    orderNumber: string,
    dealerCode: string,
    shipmentStatus: string,
    pageNumber: number,
    pageSize: number,
    shipmentDateFrom: string,
    shipmentDateTo: string,
    orderDateFrom: string,
    orderDateTo: string
): IDataServiceRequest {
    const query = getShipmentDetailsActionQuery();
    return query.createDataServiceRequestForOperation(
        'GetShipmentDetailsAction',
        true,
        DataServiceEntities.ApiResponseForShipmentExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseForShipment' },
        {
            orderNumber: orderNumber,
            dealerCode: dealerCode,
            shipmentStatus: shipmentStatus,
            pageNumber: pageNumber,
            pageSize: pageSize,
            shipmentDateFrom: shipmentDateFrom,
            shipmentDateTo: shipmentDateTo,
            orderDateFrom: orderDateFrom,
            orderDateTo: orderDateTo
        }
    );
}

export function getShipmentDetailsActionAsync(
    context: IContext,
    orderNumber: string,
    dealerCode: string,
    shipmentStatus: string,
    pageNumber: number,
    pageSize: number,
    shipmentDateFrom: string,
    shipmentDateTo: string,
    orderDateFrom: string,
    orderDateTo: string
): AsyncResult<DataServiceEntities.IApiResponseForShipment> {
    const request = getShipmentDetailsActionInput(
        orderNumber,
        dealerCode,
        shipmentStatus,
        pageNumber,
        pageSize,
        shipmentDateFrom,
        shipmentDateTo,
        orderDateFrom,
        orderDateTo
    );
    return callActionOrExecute<DataServiceEntities.IApiResponseForShipment>(request, context.callerContext);
}

function getInvoiceHeaderDetailsActionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getInvoiceHeaderDetailsActionInput(
    orderNumber: string,
    dealercode: string,
    pageNumber: number,
    pageSize: number,
    invoiceNumber: string,
    invoiceDateFrom: string,
    invoiceDateTo: string
): IDataServiceRequest {
    const query = getInvoiceHeaderDetailsActionQuery();
    return query.createDataServiceRequestForOperation(
        'GetInvoiceHeaderDetailsAction',
        true,
        DataServiceEntities.ApiResponseForinvoiceHeaderExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseForinvoiceHeader' },
        {
            orderNumber: orderNumber,
            dealercode: dealercode,
            pageNumber: pageNumber,
            pageSize: pageSize,
            invoiceNumber: invoiceNumber,
            invoiceDateFrom: invoiceDateFrom,
            invoiceDateTo: invoiceDateTo
        }
    );
}

export function getInvoiceHeaderDetailsActionAsync(
    context: IContext,
    orderNumber: string,
    dealercode: string,
    pageNumber: number,
    pageSize: number,
    invoiceNumber: string,
    invoiceDateFrom: string,
    invoiceDateTo: string
): AsyncResult<DataServiceEntities.IApiResponseForinvoiceHeader> {
    const request = getInvoiceHeaderDetailsActionInput(
        orderNumber,
        dealercode,
        pageNumber,
        pageSize,
        invoiceNumber,
        invoiceDateFrom,
        invoiceDateTo
    );
    return callActionOrExecute<DataServiceEntities.IApiResponseForinvoiceHeader>(request, context.callerContext);
}

function getInvoiceLineDetailsActionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getInvoiceLineDetailsActionInput(orderNumber: string, dealercode: string, invoiceNumber: string): IDataServiceRequest {
    const query = getInvoiceLineDetailsActionQuery();
    return query.createDataServiceRequestForOperation(
        'GetInvoiceLineDetailsAction',
        true,
        DataServiceEntities.ApiResponseForinvoiceLineExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseForinvoiceLine' },
        {
            orderNumber: orderNumber,
            dealercode: dealercode,
            invoiceNumber: invoiceNumber
        }
    );
}

export function getInvoiceLineDetailsActionAsync(
    context: IContext,
    orderNumber: string,
    dealercode: string,
    invoiceNumber: string
): AsyncResult<DataServiceEntities.IApiResponseForinvoiceLine> {
    const request = getInvoiceLineDetailsActionInput(orderNumber, dealercode, invoiceNumber);
    return callActionOrExecute<DataServiceEntities.IApiResponseForinvoiceLine>(request, context.callerContext);
}

function getPaymentOustandingDetailsActionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getPaymentOustandingDetailsActionInput(
    dealercode: string,
    pageNumber: number,
    pageSize: number,
    oustandingAmount: string,
    dueDateFrom: string,
    dueDateTo: string
): IDataServiceRequest {
    const query = getPaymentOustandingDetailsActionQuery();
    return query.createDataServiceRequestForOperation(
        'GetPaymentOustandingDetailsAction',
        true,
        DataServiceEntities.ApiResponseForPaymentOutstandingExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseForPaymentOutstanding' },
        {
            dealercode: dealercode,
            pageNumber: pageNumber,
            pageSize: pageSize,
            oustandingAmount: oustandingAmount,
            dueDateFrom: dueDateFrom,
            dueDateTo: dueDateTo
        }
    );
}

export function getPaymentOustandingDetailsActionAsync(
    context: IContext,
    dealercode: string,
    pageNumber: number,
    pageSize: number,
    oustandingAmount: string,
    dueDateFrom: string,
    dueDateTo: string
): AsyncResult<DataServiceEntities.IApiResponseForPaymentOutstanding> {
    const request = getPaymentOustandingDetailsActionInput(dealercode, pageNumber, pageSize, oustandingAmount, dueDateFrom, dueDateTo);
    return callActionOrExecute<DataServiceEntities.IApiResponseForPaymentOutstanding>(request, context.callerContext);
}

function getCustomerCreditLimitDetailsActionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCustomerCreditLimitDetailsActionInput(
    dealercode: string,
    dealerCreditLimit: string,
    dealerStatus: string,
    pageNumber: number,
    pageSize: number
): IDataServiceRequest {
    const query = getCustomerCreditLimitDetailsActionQuery();
    return query.createDataServiceRequestForOperation(
        'GetCustomerCreditLimitDetailsAction',
        true,
        DataServiceEntities.ApiResponseForCustomerCreditLimitExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IApiResponseForCustomerCreditLimit' },
        {
            dealercode: dealercode,
            dealerCreditLimit: dealerCreditLimit,
            dealerStatus: dealerStatus,
            pageNumber: pageNumber,
            pageSize: pageSize
        }
    );
}

export function getCustomerCreditLimitDetailsActionAsync(
    context: IContext,
    dealercode: string,
    dealerCreditLimit: string,
    dealerStatus: string,
    pageNumber: number,
    pageSize: number
): AsyncResult<DataServiceEntities.IApiResponseForCustomerCreditLimit> {
    const request = getCustomerCreditLimitDetailsActionInput(dealercode, dealerCreditLimit, dealerStatus, pageNumber, pageSize);
    return callActionOrExecute<DataServiceEntities.IApiResponseForCustomerCreditLimit>(request, context.callerContext);
}

function getSOHeDataSaveActionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getSOHeDataSaveActionInput(
    queryResultSettings: IQueryResultSettings,
    retailChannelId: string,
    productCode: string,
    seriesName: string
): IDataServiceRequest {
    const query = getSOHeDataSaveActionQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetSOHeDataSaveAction',
        true,
        DataServiceEntities.SOHExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISOH' },
        {
            retailChannelId: retailChannelId,
            productCode: productCode,
            seriesName: seriesName
        }
    );
}

export function getSOHeDataSaveActionAsync(
    context: IContext,
    retailChannelId: string,
    productCode: string,
    seriesName: string
): AsyncResult<DataServiceEntities.ISOH[]> {
    const request = getSOHeDataSaveActionInput(context.queryResultSettings || {}, retailChannelId, productCode, seriesName);
    return callActionOrExecute<DataServiceEntities.ISOH[]>(request, context.callerContext);
}

// @ts-ignore
function aHIAftermarketQuery(name?: string): DataServiceQuery {
    const key = name ? { Name: name } : null;
    return new DataServiceQuery(
        'AHIAftermarket',
        'AHIAftermarketContactUsEntity',
        DataServiceEntities.AHIAftermarketContactUsEntityExtensionClass,
        key
    );
}

export function createSaveAftermarketContactUsInput(
    queryResultSettings: IQueryResultSettings,
    contactUs: DataServiceEntities.IAHIAftermarketContactUsEntity
): IDataServiceRequest {
    const query = aHIAftermarketQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SaveAftermarketContactUs',
        true,
        DataServiceEntities.AHIAftermarketContactUsEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAHIAftermarketContactUsEntity' },
        { contactUs: contactUs }
    );
}

export function saveAftermarketContactUsAsync(
    context: IContext,
    contactUs: DataServiceEntities.IAHIAftermarketContactUsEntity
): AsyncResult<DataServiceEntities.IAHIAftermarketContactUsEntity[]> {
    const request = createSaveAftermarketContactUsInput(context.queryResultSettings || {}, contactUs);
    return callActionOrExecute<DataServiceEntities.IAHIAftermarketContactUsEntity[]>(request, context.callerContext);
}

export function createGetISOCodesInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = aHIAftermarketQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetISOCodes',
        true,
        DataServiceEntities.AHIISOCodeEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAHIISOCodeEntity' },
        {}
    );
}

export function getISOCodesAsync(context: IContext): AsyncResult<DataServiceEntities.IAHIISOCodeEntity[]> {
    const request = createGetISOCodesInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IAHIISOCodeEntity[]>(request, context.callerContext);
}

export function createGetSolutionOfInterestInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = aHIAftermarketQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetSolutionOfInterest',
        true,
        DataServiceEntities.AHISOICategoryEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAHISOICategoryEntity' },
        {}
    );
}

export function getSolutionOfInterestAsync(context: IContext): AsyncResult<DataServiceEntities.IAHISOICategoryEntity[]> {
    const request = createGetSolutionOfInterestInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IAHISOICategoryEntity[]>(request, context.callerContext);
}

export function createSaveMaintenanceContractInput(
    queryResultSettings: IQueryResultSettings,
    maintenanceContract: DataServiceEntities.IAHIMaintenanceContractEntity
): IDataServiceRequest {
    const query = aHIAftermarketQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SaveMaintenanceContract',
        true,
        DataServiceEntities.AHIMaintenanceContractEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAHIMaintenanceContractEntity' },
        { maintenanceContract: maintenanceContract }
    );
}

export function saveMaintenanceContractAsync(
    context: IContext,
    maintenanceContract: DataServiceEntities.IAHIMaintenanceContractEntity
): AsyncResult<DataServiceEntities.IAHIMaintenanceContractEntity[]> {
    const request = createSaveMaintenanceContractInput(context.queryResultSettings || {}, maintenanceContract);
    return callActionOrExecute<DataServiceEntities.IAHIMaintenanceContractEntity[]>(request, context.callerContext);
}

export function createSaveAfterMarketSupportInput(
    queryResultSettings: IQueryResultSettings,
    supportRequest: DataServiceEntities.IAHIAfterMarketSupportRequestEntity
): IDataServiceRequest {
    const query = aHIAftermarketQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SaveAfterMarketSupport',
        true,
        DataServiceEntities.AHIAfterMarketSupportRequestEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAHIAfterMarketSupportRequestEntity' },
        { supportRequest: supportRequest }
    );
}

export function saveAfterMarketSupportAsync(
    context: IContext,
    supportRequest: DataServiceEntities.IAHIAfterMarketSupportRequestEntity
): AsyncResult<DataServiceEntities.IAHIAfterMarketSupportRequestEntity[]> {
    const request = createSaveAfterMarketSupportInput(context.queryResultSettings || {}, supportRequest);
    return callActionOrExecute<DataServiceEntities.IAHIAfterMarketSupportRequestEntity[]>(request, context.callerContext);
}

export function createSavePartSpareEnquiryRequestInput(
    queryResultSettings: IQueryResultSettings,
    partSpareEnquiry: DataServiceEntities.IAHIAfterMarketSpareEnquiryEntity
): IDataServiceRequest {
    const query = aHIAftermarketQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SavePartSpareEnquiryRequest',
        true,
        DataServiceEntities.AHIAfterMarketSpareEnquiryEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAHIAfterMarketSpareEnquiryEntity' },
        { partSpareEnquiry: partSpareEnquiry }
    );
}

export function savePartSpareEnquiryRequestAsync(
    context: IContext,
    partSpareEnquiry: DataServiceEntities.IAHIAfterMarketSpareEnquiryEntity
): AsyncResult<DataServiceEntities.IAHIAfterMarketSpareEnquiryEntity[]> {
    const request = createSavePartSpareEnquiryRequestInput(context.queryResultSettings || {}, partSpareEnquiry);
    return callActionOrExecute<DataServiceEntities.IAHIAfterMarketSpareEnquiryEntity[]>(request, context.callerContext);
}

// @ts-ignore
function bussinessPartnerDetailsQuery(pARTNERIDENTIFIER?: string): DataServiceQuery {
    const key = pARTNERIDENTIFIER ? { PARTNERIDENTIFIER: pARTNERIDENTIFIER } : null;
    return new DataServiceQuery(
        'BussinessPartnerDetails',
        'BussinessPartnerDetails',
        DataServiceEntities.BussinessPartnerDetailsExtensionClass,
        key
    );
}

export function createSaveBussinessPartnerDetailsInput(
    queryResultSettings: IQueryResultSettings,
    bussinessPartnerDetails: DataServiceEntities.IBussinessPartnerDetails
): IDataServiceRequest {
    const query = bussinessPartnerDetailsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SaveBussinessPartnerDetails',
        true,
        DataServiceEntities.BussinessPartnerDetailsExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IBussinessPartnerDetails' },
        { bussinessPartnerDetails: bussinessPartnerDetails }
    );
}

export function saveBussinessPartnerDetailsAsync(
    context: IContext,
    bussinessPartnerDetails: DataServiceEntities.IBussinessPartnerDetails
): AsyncResult<DataServiceEntities.IBussinessPartnerDetails[]> {
    const request = createSaveBussinessPartnerDetailsInput(context.queryResultSettings || {}, bussinessPartnerDetails);
    return callActionOrExecute<DataServiceEntities.IBussinessPartnerDetails[]>(request, context.callerContext);
}

export function createGetBussinessPartnerDetailsInput(
    queryResultSettings: IQueryResultSettings,
    customerAccount: string
): IDataServiceRequest {
    const query = bussinessPartnerDetailsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetBussinessPartnerDetails',
        true,
        DataServiceEntities.BussinessPartnerDetailsExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IBussinessPartnerDetails' },
        { customerAccount: customerAccount }
    );
}

export function getBussinessPartnerDetailsAsync(
    context: IContext,
    customerAccount: string
): AsyncResult<DataServiceEntities.IBussinessPartnerDetails[]> {
    const request = createGetBussinessPartnerDetailsInput(context.queryResultSettings || {}, customerAccount);
    return callActionOrExecute<DataServiceEntities.IBussinessPartnerDetails[]>(request, context.callerContext);
}

export function createAHIUploadToSharepointInput(
    queryResultSettings: IQueryResultSettings,
    uploadSharepoint: DataServiceEntities.IAHIUploadSharepointEntity
): IDataServiceRequest {
    const query = bussinessPartnerDetailsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'AHIUploadToSharepoint',
        true,
        DataServiceEntities.UploadResultExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IUploadResult' },
        { uploadSharepoint: uploadSharepoint }
    );
}

export function aHIUploadToSharepointAsync(
    context: IContext,
    uploadSharepoint: DataServiceEntities.IAHIUploadSharepointEntity
): AsyncResult<DataServiceEntities.IUploadResult[]> {
    const request = createAHIUploadToSharepointInput(context.queryResultSettings || {}, uploadSharepoint);
    return callActionOrExecute<DataServiceEntities.IUploadResult[]>(request, context.callerContext);
}

// @ts-ignore
function aHIGetSubMastersDataQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'AHIGetSubMastersData',
        'AHICartSubMasterEntity',
        DataServiceEntities.AHICartSubMasterEntityExtensionClass,
        key
    );
}

export function createGetAllSubMastersDataInput(queryResultSettings: IQueryResultSettings, subMasterType: string): IDataServiceRequest {
    const query = aHIGetSubMastersDataQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllSubMastersData',
        true,
        DataServiceEntities.AHICartSubMasterEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAHICartSubMasterEntity' },
        { subMasterType: subMasterType }
    );
}

export function getAllSubMastersDataAsync(
    context: IContext,
    subMasterType: string
): AsyncResult<DataServiceEntities.IAHICartSubMasterEntity[]> {
    const request = createGetAllSubMastersDataInput(context.queryResultSettings || {}, subMasterType);
    return callActionOrExecute<DataServiceEntities.IAHICartSubMasterEntity[]>(request, context.callerContext);
}

// @ts-ignore
function aHIRequestAssistanceQuery(idColumnEntry?: number): DataServiceQuery {
    const key = idColumnEntry ? { idColumnEntry: idColumnEntry } : null;
    return new DataServiceQuery('AHIRequestAssistance', 'RequestAssitance', DataServiceEntities.RequestAssitanceExtensionClass, key);
}

export function createGetRequestAssitanceDataSaveActionInput(
    queryResultSettings: IQueryResultSettings,
    requestAssistance: DataServiceEntities.IRequestAssitance
): IDataServiceRequest {
    const query = aHIRequestAssistanceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetRequestAssitanceDataSaveAction',
        true,
        DataServiceEntities.RequestAssitanceExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IRequestAssitance' },
        { requestAssistance: requestAssistance }
    );
}

export function getRequestAssitanceDataSaveActionAsync(
    context: IContext,
    requestAssistance: DataServiceEntities.IRequestAssitance
): AsyncResult<DataServiceEntities.IRequestAssitance[]> {
    const request = createGetRequestAssitanceDataSaveActionInput(context.queryResultSettings || {}, requestAssistance);
    return callActionOrExecute<DataServiceEntities.IRequestAssitance[]>(request, context.callerContext);
}

// @ts-ignore
function iTCybersourceControllerQuery(reference_number?: string): DataServiceQuery {
    const key = reference_number ? { reference_number: reference_number } : null;
    return new DataServiceQuery(
        'ITCybersourceController',
        'CybersourceSignatureRequestEntity',
        DataServiceEntities.CybersourceSignatureRequestEntityExtensionClass,
        key
    );
}

export function createGetCyberSourceSingatureActionInput(
    cybersourceRequestDataEntity: DataServiceEntities.ICybersourceRequestDataEntity
): IDataServiceRequest {
    const query = iTCybersourceControllerQuery();
    return query.createDataServiceRequestForOperation(
        'GetCyberSourceSingatureAction',
        true,
        DataServiceEntities.CybersourceSignatureRequestEntityExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICybersourceSignatureRequestEntity' },
        { cybersourceRequestDataEntity: cybersourceRequestDataEntity }
    );
}

export function getCyberSourceSingatureActionAsync(
    context: IContext,
    cybersourceRequestDataEntity: DataServiceEntities.ICybersourceRequestDataEntity
): AsyncResult<DataServiceEntities.ICybersourceSignatureRequestEntity> {
    const request = createGetCyberSourceSingatureActionInput(cybersourceRequestDataEntity);
    return callActionOrExecute<DataServiceEntities.ICybersourceSignatureRequestEntity>(request, context.callerContext);
}

export function createPostCybersourceResponseActionInput(cybersourceResponseContract: string): IDataServiceRequest {
    const query = iTCybersourceControllerQuery();
    return query.createDataServiceRequestForOperation(
        'PostCybersourceResponseAction',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { cybersourceResponseContract: cybersourceResponseContract }
    );
}

export function postCybersourceResponseActionAsync(context: IContext, cybersourceResponseContract: string): AsyncResult<string> {
    const request = createPostCybersourceResponseActionInput(cybersourceResponseContract);
    return callActionOrExecute<string>(request, context.callerContext);
}

export function createConfirmOrdersByCybersourceTransactionDetailsActionInput(
    transactionId: string,
    cybersourceTransId: string
): IDataServiceRequest {
    const query = iTCybersourceControllerQuery();
    return query.createDataServiceRequestForOperation(
        'ConfirmOrdersByCybersourceTransactionDetailsAction',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { transactionId: transactionId, cybersourceTransId: cybersourceTransId }
    );
}

export function confirmOrdersByCybersourceTransactionDetailsActionAsync(
    context: IContext,
    transactionId: string,
    cybersourceTransId: string
): AsyncResult<string> {
    const request = createConfirmOrdersByCybersourceTransactionDetailsActionInput(transactionId, cybersourceTransId);
    return callActionOrExecute<string>(request, context.callerContext);
}

// @ts-ignore
function aHIISRequestAssistanceProductQuery(idColEntry?: string): DataServiceQuery {
    const key = idColEntry ? { idColEntry: idColEntry } : null;
    return new DataServiceQuery(
        'AHIISRequestAssistanceProduct',
        'RequestAssistanceIsProduct',
        DataServiceEntities.RequestAssistanceIsProductExtensionClass,
        key
    );
}

export function createGetISRequestAssitanceProductActionInput(
    requestAssistanceIsProduct: DataServiceEntities.IRequestAssistanceIsProduct,
    productId: number
): IDataServiceRequest {
    const query = aHIISRequestAssistanceProductQuery();
    return query.createDataServiceRequestForOperation(
        'GetISRequestAssitanceProductAction',
        true,
        DataServiceEntities.RequestAssistanceIsProductExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IRequestAssistanceIsProduct' },
        { requestAssistanceIsProduct: requestAssistanceIsProduct, productId: productId }
    );
}

export function getISRequestAssitanceProductActionAsync(
    context: IContext,
    requestAssistanceIsProduct: DataServiceEntities.IRequestAssistanceIsProduct,
    productId: number
): AsyncResult<DataServiceEntities.IRequestAssistanceIsProduct> {
    const request = createGetISRequestAssitanceProductActionInput(requestAssistanceIsProduct, productId);
    return callActionOrExecute<DataServiceEntities.IRequestAssistanceIsProduct>(request, context.callerContext);
}

// @ts-ignore
function configurableItemEntityQuery(rECID?: number): DataServiceQuery {
    const key = rECID ? { RECID: rECID } : null;
    return new DataServiceQuery(
        'ConfigurableItemEntity',
        'ConfigurableItemEntity',
        DataServiceEntities.ConfigurableItemEntityExtensionClass,
        key
    );
}

export function createGetConfigurableItemsControllerInput(
    queryResultSettings: IQueryResultSettings,
    masterProductItemId: string,
    sizeVarient: string,
    colorVarient: string,
    styleVarient: string,
    config: string
): IDataServiceRequest {
    const query = configurableItemEntityQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetConfigurableItemsController',
        true,
        DataServiceEntities.ConfigurableItemEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IConfigurableItemEntity' },
        {
            masterProductItemId: masterProductItemId,
            sizeVarient: sizeVarient,
            colorVarient: colorVarient,
            styleVarient: styleVarient,
            config: config
        }
    );
}

export function getConfigurableItemsControllerAsync(
    context: IContext,
    masterProductItemId: string,
    sizeVarient: string,
    colorVarient: string,
    styleVarient: string,
    config: string
): AsyncResult<DataServiceEntities.IConfigurableItemEntity[]> {
    const request = createGetConfigurableItemsControllerInput(
        context.queryResultSettings || {},
        masterProductItemId,
        sizeVarient,
        colorVarient,
        styleVarient,
        config
    );
    return callActionOrExecute<DataServiceEntities.IConfigurableItemEntity[]>(request, context.callerContext);
}

export function createGetSimpleProductsControllerInput(
    queryResultSettings: IQueryResultSettings,
    productIds: number[],
    channelId: number,
    colorVarient: string,
    styleVarient: string,
    config: string
): IDataServiceRequest {
    const query = configurableItemEntityQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetSimpleProductsController',
        true,
        EntityClasses.SimpleProductClass,
        'true',
        { bypassCache: 'none', returnEntity: 'Entities.SimpleProduct' },
        { productIds: productIds, channelId: channelId, colorVarient: colorVarient, styleVarient: styleVarient, config: config }
    );
}

export function getSimpleProductsControllerAsync(
    context: IContext,
    productIds: number[],
    channelId: number,
    colorVarient: string,
    styleVarient: string,
    config: string
): AsyncResult<Entities.SimpleProduct[]> {
    const request = createGetSimpleProductsControllerInput(
        context.queryResultSettings || {},
        productIds,
        channelId,
        colorVarient,
        styleVarient,
        config
    );
    return callActionOrExecute<Entities.SimpleProduct[]>(request, context.callerContext);
}

export function createSaveConfigurableSalesLineControllerInput(cartId: string): IDataServiceRequest {
    const query = configurableItemEntityQuery();
    return query.createDataServiceRequestForOperation(
        'SaveConfigurableSalesLineController',
        true,
        DataServiceEntities.SaveConfigurableSalesLineResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISaveConfigurableSalesLineResponse' },
        { cartId: cartId }
    );
}

export function saveConfigurableSalesLineControllerAsync(
    context: IContext,
    cartId: string
): AsyncResult<DataServiceEntities.ISaveConfigurableSalesLineResponse> {
    const request = createSaveConfigurableSalesLineControllerInput(cartId);
    return callActionOrExecute<DataServiceEntities.ISaveConfigurableSalesLineResponse>(request, context.callerContext);
}

// @ts-ignore
function cateoryDetailsEntityQuery(rECID?: number): DataServiceQuery {
    const key = rECID ? { RECID: rECID } : null;
    return new DataServiceQuery(
        'CateoryDetailsEntity',
        'CateoryDetailsEntity',
        DataServiceEntities.CateoryDetailsEntityExtensionClass,
        key
    );
}

export function createGetCategoryDetailsControllerInput(queryResultSettings: IQueryResultSettings, recId: number): IDataServiceRequest {
    const query = cateoryDetailsEntityQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCategoryDetailsController',
        true,
        DataServiceEntities.CateoryDetailsEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICateoryDetailsEntity' },
        { recId: recId }
    );
}

export function getCategoryDetailsControllerAsync(
    context: IContext,
    recId: number
): AsyncResult<DataServiceEntities.ICateoryDetailsEntity[]> {
    const request = createGetCategoryDetailsControllerInput(context.queryResultSettings || {}, recId);
    return callActionOrExecute<DataServiceEntities.ICateoryDetailsEntity[]>(request, context.callerContext);
}

// @ts-ignore
function categoryStructureProductWithSeriesEntityQuery(iDCOLEntry?: string): DataServiceQuery {
    const key = iDCOLEntry ? { IDCOLEntry: iDCOLEntry } : null;
    return new DataServiceQuery(
        'CategoryStructureProductWithSeriesEntity',
        'CategoryStructureProductWithSeriesEntity',
        DataServiceEntities.CategoryStructureProductWithSeriesEntityExtensionClass,
        key
    );
}

export function createGetCategoryStructureProductSeriesDataControllerInput(
    queryResultSettings: IQueryResultSettings,
    recId: number
): IDataServiceRequest {
    const query = categoryStructureProductWithSeriesEntityQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCategoryStructureProductSeriesDataController',
        true,
        DataServiceEntities.CategoryStructureProductWithSeriesEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICategoryStructureProductWithSeriesEntity' },
        { recId: recId }
    );
}

export function getCategoryStructureProductSeriesDataControllerAsync(
    context: IContext,
    recId: number
): AsyncResult<DataServiceEntities.ICategoryStructureProductWithSeriesEntity[]> {
    const request = createGetCategoryStructureProductSeriesDataControllerInput(context.queryResultSettings || {}, recId);
    return callActionOrExecute<DataServiceEntities.ICategoryStructureProductWithSeriesEntity[]>(request, context.callerContext);
}

// @ts-ignore
function subCategoryStructureEntityQuery(rECID?: number): DataServiceQuery {
    const key = rECID ? { RECID: rECID } : null;
    return new DataServiceQuery(
        'SubCategoryStructureEntity',
        'SubCategoryStructureEntity',
        DataServiceEntities.SubCategoryStructureEntityExtensionClass,
        key
    );
}

export function createGetSubCategoryStructureControllerInput(
    queryResultSettings: IQueryResultSettings,
    recId: number
): IDataServiceRequest {
    const query = subCategoryStructureEntityQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetSubCategoryStructureController',
        true,
        DataServiceEntities.SubCategoryStructureEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ISubCategoryStructureEntity' },
        { recId: recId }
    );
}

export function getSubCategoryStructureControllerAsync(
    context: IContext,
    recId: number
): AsyncResult<DataServiceEntities.ISubCategoryStructureEntity[]> {
    const request = createGetSubCategoryStructureControllerInput(context.queryResultSettings || {}, recId);
    return callActionOrExecute<DataServiceEntities.ISubCategoryStructureEntity[]>(request, context.callerContext);
}
